import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/context/AuthContext";
import { Menubar, MenubarMenu, MenubarTrigger } from "@/components/ui/menubar";
import { cn } from "@/lib/utils";
import { Anchor, Clipboard, Package, Settings, LifeBuoy, LayoutDashboard } from "lucide-react";
import UserProfile from "./UserProfile";
import LanguageSwitcher from "./LanguageSwitcher";
import NauticLogo from "@/components/ui/NauticLogo";

const menuItems = [
  { labelKey: "nav.dashboard", href: "/dashboard", icon: LayoutDashboard },
  { labelKey: "nav.boats", href: "/mes-bateaux", icon: Anchor },
  { labelKey: "nav.maintenance", href: "/maintenance", icon: Settings },
  { labelKey: "nav.inventory", href: "/inventory", icon: Package },
  { labelKey: "nav.checklists", href: "/checklists", icon: Clipboard },
  { labelKey: "nav.assistant", href: "/assistant", icon: LifeBuoy },
];

const TopMenu = () => {
  const { user } = useAuth();
  const { t } = useTranslation("common");
  const currentPath = window.location.pathname;

  return (
    <Menubar className="rounded-none border-b border-none bg-nautic px-2 lg:px-4 h-16 items-center">
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center gap-6 md:gap-10">
          <Link to={user ? "/dashboard" : "/"} className="flex items-center">
            <NauticLogo withText textSize="md" className="text-nautic-gold" />
          </Link>
          
          {user && (
            <div className="hidden md:flex items-center space-x-4">
              {menuItems.map((item) => (
                <MenubarMenu key={item.href}>
                  <Link to={item.href}>
                    <MenubarTrigger 
                      className={cn(
                        "text-white hover:text-nautic-gold hover:bg-nautic-light cursor-pointer",
                        currentPath === item.href && "text-nautic-gold font-medium"
                      )}
                    >
                      <item.icon className="h-4 w-4 mr-2" />
                      {t(item.labelKey)}
                    </MenubarTrigger>
                  </Link>
                </MenubarMenu>
              ))}
            </div>
          )}
        </div>
        
        <div className="flex items-center gap-3">
          <LanguageSwitcher variant="dark" />
          {user ? (
            <UserProfile />
          ) : (
            <Link 
              to="/auth" 
              className="text-nautic-gold hover:text-nautic-lightgold transition-colors font-medium"
            >
              {t("nav.login")}
            </Link>
          )}
        </div>
      </div>
    </Menubar>
  );
};

export default TopMenu;
